import axios from 'axios';
import Config from '../../config';
import { DELETE_MODAL_CLOSE, MODAL_CLOSE } from '../actions';
import { toast } from 'react-toastify';
import {
    CREATE_SEASON_MASTER_FAILURE,
    CREATE_SEASON_MASTER_REQUEST,
    CREATE_SEASON_MASTER_SUCCESS,
    CREATE_USER_FORM_SEASON_MASTER,
    DELETE_SEASON_MASTER_FAILURE,
    DELETE_SEASON_MASTER_REQUEST,
    DELETE_SEASON_MASTER_SUCCESS,
    FETCH_SEASON_MASTER_FAILURE,
    FETCH_SEASON_MASTER_REQUEST,
    FETCH_SEASON_MASTER_SUCCESS,
    FETCH_SINGLE_SEASON_MASTER_FAILURE,
    FETCH_SINGLE_SEASON_MASTER_REQUEST,
    FETCH_SINGLE_SEASON_MASTER_SUCCESS,
    SEASON_MASTER_USERFORM_RESET,
    UPDATE_SEASON_MASTER_FAILURE,
    UPDATE_SEASON_MASTER_REQUEST,
    UPDATE_SEASON_MASTER_SUCCESS
} from './seasonMaster.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

// FETCH PROPERTY MASTER
export let fetchSeasonMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.seasonMasterGET,
        responseTypeRequest: FETCH_SEASON_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SEASON_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SEASON_MASTER_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createSeasonUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_SEASON_MASTER, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createSeasonMaster = (formData, button) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        ...formData,
        fldSeasonCode: 'Auto Generated',
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.seasonMasterPOST}`,
        responseTypeRequest: CREATE_SEASON_MASTER_REQUEST,
        responseTypeSuccess: CREATE_SEASON_MASTER_SUCCESS,
        responseTypeFailure: CREATE_SEASON_MASTER_FAILURE,
        resetFormData: SEASON_MASTER_USERFORM_RESET,
        modalClose: button === 'addNew' ? false : true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSeasonMaster()
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleSeasonMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.seasonMasterGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_SEASON_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_SEASON_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_SEASON_MASTER_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateSeasonMaster = (formData) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldModifiedDt: today.toISOString()
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.seasonMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_SEASON_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_SEASON_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_SEASON_MASTER_FAILURE,
        resetFormData: SEASON_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSeasonMaster()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteSeasonMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.seasonMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_SEASON_MASTER_REQUEST,
        responseTypeSuccess: DELETE_SEASON_MASTER_SUCCESS,
        responseTypeFailure: DELETE_SEASON_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchSeasonMaster()
    };
    return axiosCall(config);
};
